import Vue from 'vue'
import { createHelpers } from 'vuex-map-fields'
import _ from 'lodash'

import {
  // GET_INSURANCE_PLAN
  GET_INSURANCE_PLAN_REQUEST,
  GET_INSURANCE_PLAN_SUCCESS,
  GET_INSURANCE_PLAN_FAILURE,

  // GET_INSURANCE_DEDUCT_PLAN
  GET_INSURANCE_DEDUCT_PLAN_REQUEST,
  GET_INSURANCE_DEDUCT_PLAN_SUCCESS,
  GET_INSURANCE_DEDUCT_PLAN_FAILURE,

  // GENERATE_QUICK_QUOTATION_DOCUMENT
  GENERATE_QUICK_QUOTATION_DOCUMENT_REQUEST,
  GENERATE_QUICK_QUOTATION_DOCUMENT_SUCCESS,
  GENERATE_QUICK_QUOTATION_DOCUMENT_FAILURE,
} from '@/lib/mutationTypes'
import API, { HOMEPAGE_URL } from '@/lib/api'
import { generateAuthorizationRequestHeader } from '@/lib/services'

const { getPlansFields, updatePlansFields } = createHelpers({
  getterType: 'getPlansFields',
  mutationType: 'updatePlansFields',
})

const state = {
  insurancePlanInformation: {
    data: null,
    isLoading: false,
    isError: false,
  },
  deductibleInformation: {
    data: null,
    isLoading: false,
    isError: false,
  },
  generatedQuickQuotation: {
    data: null,
    isLoading: false,
    isError: false,
  },
}

const mutations = {
  // GET_INSURANCE_PLAN
  [GET_INSURANCE_PLAN_REQUEST](state) {
    state.insurancePlanInformation = {
      ...state.insurancePlanInformation,
      isLoading: true,
      isError: false,
    }
  },
  [GET_INSURANCE_PLAN_SUCCESS](state, payload) {
    state.insurancePlanInformation = {
      data: payload,
      isLoading: false,
      isError: false,
    }
  },
  [GET_INSURANCE_PLAN_FAILURE](state) {
    state.insurancePlanInformation = {
      ...state.insurancePlanInformation,
      isLoading: false,
      isError: true,
    }
  },

  // GET_INSURANCE_DEDUCT_PLAN
  [GET_INSURANCE_DEDUCT_PLAN_REQUEST](state) {
    state.deductibleInformation = {
      ...state.deductibleInformation,
      isLoading: true,
      isError: false,
    }
  },
  [GET_INSURANCE_DEDUCT_PLAN_SUCCESS](state, payload) {
    state.deductibleInformation = {
      data: payload,
      isLoading: false,
      isError: false,
    }
  },
  [GET_INSURANCE_DEDUCT_PLAN_FAILURE](state) {
    state.deductibleInformation = {
      ...state.deductibleInformation,
      isLoading: false,
      isError: true,
    }
  },

  // GENERATE_QUICK_QUOTATION_DOCUMENT
  [GENERATE_QUICK_QUOTATION_DOCUMENT_REQUEST](state) {
    state.generatedQuickQuotation.isLoading = true
    state.generatedQuickQuotation.isError = false
  },
  [GENERATE_QUICK_QUOTATION_DOCUMENT_SUCCESS](state, payload) {
    state.generatedQuickQuotation.data = payload
    state.generatedQuickQuotation.isLoading = false
    state.generatedQuickQuotation.isError = false
  },
  [GENERATE_QUICK_QUOTATION_DOCUMENT_FAILURE](state) {
    state.generatedQuickQuotation.isLoading = false
    state.generatedQuickQuotation.isError = true
  },

  updatePlansFields,
}

const actions = {
  getInsurancePlanInformation({ commit }, data) {
    commit(GET_INSURANCE_PLAN_REQUEST)

    const { coverageCodes = 'IPD+PA', age } = data

    Vue.http
      .post(
        API.PACKAGE_PLAN.GET_INSURANCE_PLAN,
        { coverageCodes, age },
        {
          headers: {
            ...generateAuthorizationRequestHeader(),
          },
        },
      )
      .then(res => res.json())
      .then(
        res => commit(GET_INSURANCE_PLAN_SUCCESS, res.result),
        error => {
          const { status } = error

          switch (status) {
            case 401:
              this._vm.$session.destroy()

              return (window.location.href = HOMEPAGE_URL)

            case 403:
              return this._vm.$swal({
                type: 'error',
                title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
              })

            case 400:
            case 500:
              return commit(GET_INSURANCE_PLAN_FAILURE)

            default:
              return commit(GET_INSURANCE_PLAN_FAILURE)
          }
        },
      )
  },
  getInsuranceDeductPlanInformation({ commit }, age) {
    commit(GET_INSURANCE_DEDUCT_PLAN_REQUEST)

    Vue.http
      .post(
        API.PACKAGE_PLAN.GET_DEDUCT_PLAN,
        { age },
        {
          headers: {
            ...generateAuthorizationRequestHeader(),
          },
        },
      )
      .then(res => res.json())
      .then(
        res => commit(GET_INSURANCE_DEDUCT_PLAN_SUCCESS, res.result.deductInfo),
        error => {
          const { status } = error

          switch (status) {
            case 401:
              this._vm.$session.destroy()

              return (window.location.href = HOMEPAGE_URL)

            case 403:
              return this._vm.$swal({
                type: 'error',
                title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
              })

            case 400:
            case 500:
              return commit(GET_INSURANCE_DEDUCT_PLAN_FAILURE)

            default:
              return commit(GET_INSURANCE_DEDUCT_PLAN_FAILURE)
          }
        },
      )
  },
  generateQuickQuotationDocument({ commit }, data) {
    commit(GENERATE_QUICK_QUOTATION_DOCUMENT_REQUEST)

    Vue.http
      .post(API.PACKAGE_PLAN.GENERATE_QUICK_QUOTATION, data, {
        headers: {
          ...generateAuthorizationRequestHeader(),
        },
      })
      .then(res => res.json())
      .then(
        res => commit(GENERATE_QUICK_QUOTATION_DOCUMENT_SUCCESS, res.result.quotationUrl),
        error => {
          const { status } = error

          switch (status) {
            case 401:
              this._vm.$session.destroy()

              return (window.location.href = HOMEPAGE_URL)

            case 403:
              return this._vm.$swal({
                type: 'error',
                title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
              })

            case 400:
            case 500:
              return commit(GENERATE_QUICK_QUOTATION_DOCUMENT_FAILURE)

            default:
              return commit(GENERATE_QUICK_QUOTATION_DOCUMENT_FAILURE)
          }
        },
      )
  },
}

const getters = {
  insurancePlanInformationData: state => state.insurancePlanInformation.data,
  insurancePlanInformationIsLoading: state => state.insurancePlanInformation.isLoading,
  insurancePlanInformationIsError: state => state.insurancePlanInformation.isError,
  deductibleInformationData: state => state.deductibleInformation.data,
  deductibleInformationIsLoading: state => state.deductibleInformation.isLoading,
  deductibleInformationIsError: state => state.deductibleInformation.isError,

  getPlansFields,
}

export default {
  state,
  getters,
  mutations,
  actions,
}
